import { createSelector } from "reselect";
import getStorySharingUrl from "selectors/story/getStorySharingUrl";

const getHasCustomMonogram = (state) => state.story.hasCustomMonogram;
const getStoryCoverUrl = (_, ownProps) => ownProps.storyCoverUrl;
const getStorySlug = (state) => state.route.params.storySlug;

const getBrandingLinkClickProps = createSelector(
  getHasCustomMonogram,
  getStoryCoverUrl,
  getStorySharingUrl,
  getStorySlug,
  (hasCustomMonogram, storyCoverUrl, storySharingUrl, storySlug) => {
    const httpRegex = /((^https?:\/\/)|(\/$))/g;
    const currentUrl = window.location.href.replace(httpRegex, "");
    if (storySharingUrl && hasCustomMonogram) {
      const storySharingUrlStripped = storySharingUrl.replace(httpRegex, "");

      if (currentUrl.indexOf(storySharingUrlStripped) === 0) {
        // We're already at the custom URL.

        return {
          url: storyCoverUrl,
          openInNewWindow: false,
        };
      }
      return {
        url: storySharingUrl,
        openInNewWindow: true,
      };
    }

    return {
      url: `https://verse.com/video/${storySlug}`,
      openInNewWindow: true,
    };
  },
);

export default getBrandingLinkClickProps;
